export function submitDDQAnswer(state, payload) {
  return {
    ...state,
    currentSection: updateSubmitInCurrentSection(state.currentSection, payload),
  };
}

function updateSubmitInCurrentSection(currentSection, payload) {
  return {
    ...currentSection,
    components: updateSubmitInComponents(currentSection.components, payload),
  };
}

function updateSubmitInComponents(components, payload) {
  return components.map((component) => {
    if (component.id === payload.componentID) {
      component = updateSubmitInDDQComponent(component);
    }
    return component;
  });
}

function updateSubmitInDDQComponent(component) {
  if (component.totalAttempts === -10 || component.totalAttempts > 0) {
    const setShowFeedbackTrue = (step) => ({...step, showFeedback: true});
    const answerSteps = component.answerSteps.map(setShowFeedbackTrue);
    const totalAttempts =
      component.totalAttempts === -10 ? -10 : component.totalAttempts - 1;
    const complete = setDDQComplete(answerSteps, totalAttempts);
    return {
      ...component,
      complete,
      answerSteps,
      totalAttempts,
    };
  } else {
    return {
      ...component,
      complete: true,
      totalAttempts: 0,
    };
  }
}

function setDDQComplete(answerSteps, totalAttempts) {
  if (totalAttempts === -10 || totalAttempts >= 1) {
    return answerSteps.reduce((boolValue, step) => {
      if (step.value !== step.droppedId) {
        boolValue = false;
      }
      return boolValue;
    }, true);
  } else {
    return true;
  }
}
